<template lang="pug">
    v-layout(align-center)
        v-btn(text icon @click="onPrevButtonClick")
            v-icon fas fa-chevron-left

        v-menu(offset-y)
            template(v-slot:activator="{ on }")
                v-btn.date-button(text v-on="on" small) {{ buttonLabel }}
            v-date-picker(
                v-model="currentDate"
                first-day-of-week="1"
                no-title
                locale="sk"
                next-icon="fas fa-chevron-right"
                prev-icon="fas fa-chevron-left"
            )

        v-btn(text icon @click="onNextButtonClick")
            v-icon fas fa-chevron-right

</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment'
import { DatePeriod } from '@/model/reservation/DatePeriod'
import { DatePeriodEnum } from '@/types/enums'

interface ComponentData {
  currentDate: string
}

export default Vue.extend({
  name: 'PeriodSelector',

  props: {
    periodType: {
      type: String as () => DatePeriodEnum,
      default: DatePeriodEnum.Month
    }
  },

  data (): ComponentData {
    return {
      currentDate: moment().add(1, 'd').format('YYYY-MM-DD')
    }
  },

  computed: {
    buttonLabel (): string {

      let begin = moment(this.currentDate).startOf(DatePeriodEnum.Month)
      let end = moment(this.currentDate).endOf(DatePeriodEnum.Month)

      if (this.periodType === DatePeriodEnum.Week) {
        begin = moment(this.currentDate).isoWeekday(1).startOf('isoWeek')
        end = moment(this.currentDate).isoWeekday(1).endOf('isoWeek')
      }

      if (this.periodType === DatePeriodEnum.Day) {
        begin = moment(this.currentDate).startOf(DatePeriodEnum.Day)
        end = moment(this.currentDate).endOf(DatePeriodEnum.Day)
      }

      let beginStr, endStr

      const beginMonth = begin.format('MMM')
      const endMonth = end.format('MMM')

      if (beginMonth === endMonth) {
        beginStr = begin.format('DD')
        endStr = end.locale('sk').format('DD MMM')
      } else {
        beginStr = begin.format('DD MMM')
        endStr = end.locale('sk').format('DD MMM')
      }

      const yearStr = end.format('YYYY')

      if (this.periodType === DatePeriodEnum.Day) {
        beginStr = begin.locale('sk').format('DD MMMM')
        return `${beginStr} ${yearStr}`
      } else {
        return `${beginStr} - ${endStr} ${yearStr}`
      }
    }
  },

  watch: {
    currentDate (newValue: string): void {
      this.$emit('periodSelected', DatePeriod.createFromDateString(newValue, this.periodType))
    },

    periodType (newValue: DatePeriodEnum): void {
      this.$emit('periodSelected', DatePeriod.createFromDateString(this.currentDate, newValue))
    },
  },

  methods: {
    onPrevButtonClick (): void {
      let periodCode: moment.unitOfTime.DurationConstructor = DatePeriodEnum.Month

      if (this.periodType === DatePeriodEnum.Week) {
        periodCode = DatePeriodEnum.Week
      }
      if (this.periodType === DatePeriodEnum.Day) {
        periodCode = DatePeriodEnum.Day
        this.currentDate = moment(this.currentDate).subtract(1, periodCode).format('YYYY-MM-DD')
      } else {
        this.currentDate = moment(this.currentDate).isoWeekday(1).subtract(1, periodCode).format('YYYY-MM-DD')
      }
    },

    onNextButtonClick (): void {
      let periodCode: moment.unitOfTime.DurationConstructor = DatePeriodEnum.Month

      if (this.periodType === DatePeriodEnum.Week) {
        periodCode = DatePeriodEnum.Week
      }
      if (this.periodType === DatePeriodEnum.Day) {
        periodCode = DatePeriodEnum.Day
        this.currentDate = moment(this.currentDate).add(1, periodCode).format('YYYY-MM-DD')
      } else {
        this.currentDate = moment(this.currentDate).isoWeekday(1).add(1, periodCode).format('YYYY-MM-DD')
      }
    }
  }
})
</script>

<style lang="stylus" scoped>
    .date-button
        width 140px
        text-transform none

</style>
